import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Divider,
  InfoTimeCard,
  TableAdv,
  PageHeader,
  PageTitle,
} from '../../../../components';
import { mapTableRows } from '../../../../utils';
import EmailPreview from '../Modals/EmailPreview';


const EmailSent = () => {
  const [model, setModel] = useState(false);
  const navigate = useNavigate();

  const handleEmailClick = (row) => {
    setModel(true);
  };

  const columns = [
    {
      key: "Status",
      label: "Status",
    },
    {
      key: "EmailSubject",
      label: "Email Subject",
      render: (row) => (
        <div
          className="text-linkblue underline cursor-pointer"
          onClick={() => handleEmailClick(row)}
        >
          {row.EmailSubject}
        </div>
      ),
    },
    {
      key: "Recipient",
      label: "Recipient",
    },
    {
      key: "DateandTime",
      label: "Date and Time",
    },
  ];

  const rowdata = [
    {
      Status: "----",
      EmailSubject: "Invoice created",
      Recipient: "example@gmail.com",
      DateandTime: "16-03-2025 05:32:48 pm",
    },
    {
      Status: "----",
      EmailSubject: "Invoice sent",
      Recipient: "example@gmail.com",
      DateandTime: "16-03-2025 06:00:00 pm",
    },
  ];

  const onBack = () => navigate("/invoices");
  const mappedRows = mapTableRows(rowdata, columns);
  return (
    <div className="p-4">
      <PageHeader
        Section={
          <div className="flex justify-between items-center w-full">
            <PageTitle title="Invoice - Email History" tag="h6" />
            <div className="flex gap-3">
              <Button
                size="sm"
                title="Back"
                icon="arrow_left_alt"
                onClick={onBack}
              />
              <Button
                size="sm"
                title="Refresh"
                icon="docs"
                onClick={() => navigate('/invoices/mail-sent')}
              />
            </div>
          </div>
        }
      />


      <div className="mt-6 bg-white rounded shadow-md p-6">
        <h6 className="font-semibold text-gray-800 mb-2">NEW MESSAGE</h6>
        <Divider />
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-6 mt-4">
          <div>
            <p className="font-medium text-gray-700">Invoice Number:</p>
            <p className="text-gray-900">16464</p>
          </div>
          <div>
            <p className="font-medium text-gray-700">Client Name:</p>
            <p className="text-gray-900">VDart Inc</p>
          </div>
          <div>
            <p className="font-medium text-gray-700">Invoice Amount:</p>
            <p className="text-gray-900">147833.33 USD</p>
          </div>
          <div>
            <InfoTimeCard
              title="Total Due"
              color="primary"
              value={"147833.72"}
              suffix={"USD"}
              type2
            />
          </div>
        </div>
      </div>


      <div className="mt-6">
        <TableAdv tableId={`invoices_invoicedetails_emailsent`} rows={mappedRows} columns={columns} hideToolBar />
      </div>

 
      <EmailPreview open={model} onClose={() => setModel(false)} />
    </div>
  );
};

export default EmailSent;
